import Vue from 'vue';
import claimsDirective from '@/directives/claims';

Vue.directive('claims', claimsDirective);
